import { atom } from "recoil";

export const toastAtom = atom({
	key: "toastAtom",
	default: {
		life: 6000,
	},
});
